<template>
  <header class="header">
    <h2 class="box__title text--ellipsis">
      {{ $t('Common.latestRides') }}
    </h2>

    <router-link
      v-if="isSuccess"
      :to="route"
      :title="$t('Common.seeMore')"
      class="action"
    >
      <span>{{ $t('Common.seeMore') }}</span>
      <v-icon color="primary" small>add</v-icon>
    </router-link>
  </header>
</template>

<script>
import { STATUS_SUCCESS } from 'utils/constants'

export default {
  name: 'Header',
  props: {
    route: {
      type: Object
    },
    status: {
      type: Number
    }
  },
  computed: {
    isSuccess () {
      return this.status === STATUS_SUCCESS
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 8px;
  position: relative;
}

.box__title {
  padding-right: 80px;
}

a.action {
  align-items: center;
  display: flex;
  font-size: $base-font-size - 1px;
  line-height: 1;
  position: absolute;
  right: 0;
  text-decoration: none;
  top: 50%;
  transform: translateY(-50%);

  &:hover {

    span {
      text-decoration: underline;
    }
  }
}
</style>
